import {
    addToChainAfter,
    Handler,
    HandlerProps,
    HasOnError,
    HasOnSuccess
} from "@insite/client-framework/HandlerCreator";
import { GetProductByPathApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach((o: HandlerType) => chain.push(o));
    });
}

type Parameter = {
    path: string;
    addToRecentlyViewed?: boolean;
} & HasOnSuccess<ProductModel> & HasOnError<string>;
type Props = {
    apiParameter: GetProductByPathApiV2Parameter;
    apiResult: ProductModel;
};

type HandlerType = Handler<Parameter, Props>;

const AddAdditionalExpands: HandlerType = (props: HandlerProps<Parameter, Props>) => {
    props.apiParameter = {
        ...props.apiParameter,
        additionalExpands: ["properties"]
    };
};

addToChainAfter(
    chain,
    PopulateApiParameter,
    AddAdditionalExpands
);
